import styled from "styled-components";

import { MuiButton, WrapperButton } from "@ryde/controls";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueMui, deepPurpleMui, MOBILE_BREAKPOINT } from "@ryde/theme";

export const EditGridColumnButtonStyled = styled(
  WrapperButton,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "edit-grid-column-button",
})`
  color: ${deepPurpleMui.A700};
  margin-inline-start: 14px;

  .EditGridColumnSVG {
    width: auto;
    height: 20px;
    display: block;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-inline-start: 7px;
  }
`;

export const MapToggleButtonStyled = styled(
  WrapperButton,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "map-toggle-button",
})`
  color: ${deepPurpleMui.A700};
  display: flex;
  align-items: center;
  gap: 3px;
  label {
    cursor: pointer;
  }
  .MapToggleButtonSVG {
    width: auto;
    height: 22px;
    display: block;
  }
`;

export const CustomProductionToggleButtonStyled = styled(
  WrapperButton,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "custom-production-toggle-button",
})`
  color: ${blueMui.A200};
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const AssignDocksButtonStyled = styled(
  MuiButton,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "assign-docks-button",
})`
  margin-inline-end: 10px;
  margin-top: 2px;
  div {
    gap: 10px;
  }

  &.icon-only {
    min-width: 36px;
    padding-inline: 6px;
    margin-inline-end: 6px;

    div {
      gap: 0;
    }
  }
`;

export const RidesSelectAllWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-select-all-wrapper",
})`
  display: flex;
  align-items: center;
  margin-inline-start: 2px;
  margin-inline-end: 11px;
  svg {
    margin-inline-end: 8px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-inline-end: 6px;

    svg {
      margin-inline-end: 4px;
    }
  }
`;

export const RidesSelectAllIconButton = styled.button.attrs<IStyledAttributes>({
  type: "button",
  [DATA_E2E_KEY]: "ride-select-all-icon-button",
})`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  margin: 0;
  margin-inline-start: -2px;
  margin-top: 2px;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;

  .select-all-icon {
    color: ${deepPurpleMui.A700};
    display: block;
    font-size: 18px;
  }
`;

export const NearByButtonStyled = styled(
  WrapperButton,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "near-by-button",
})`
  color: ${deepPurpleMui.A700};
  display: flex;
  align-items: center;
  gap: 3px;
  margin-inline-start: 10px;

  label {
    cursor: pointer;
  }

  .NearByButtonSVG {
    width: auto;
    height: 22px;

    display: block;
  }
`;
